import {
  Box,
  FormHelperText,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { RepairShopSelectionDto } from '@src/model/repairShopDom'
import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SvvFormControl from './SvvFormControl'

export interface IUserData extends RepairShopSelectionDto {
  registrationNumber: string
}

interface UserInfoProps {
  changeHandler: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void
  userData: IUserData
  isValid: boolean
}

const UserInfo = ({
  changeHandler,
  userData,
  isValid,
}: UserInfoProps): JSX.Element => {
  const [touched, setTouched] = useState<boolean>(false)
  const { t } = useTranslation('repairshop')
  return (
    <Box
      sx={{
        backgroundColor: 'grey.100',
      }}
    >
      <Stack
        sx={{
          py: 2,
          px: 3,
          margin: 'auto',
          maxWidth: 'lg',
          backgroundColor: 'background.default',
          mt: 3,
        }}
      >
        <Typography variant="h2" component="h2" sx={{ mb: 2 }}>
          {t('pre-commit-page.check-your-information')}
        </Typography>
        <SvvFormControl
          label={t('pre-commit-page.registration-number')}
          htmlFor={'registration-number'}
          control={
            <TextField
              disabled
              id="registration-number"
              name={'registrationNumber'}
              data-testid={'registration-number'}
              type="text"
              value={userData.registrationNumber || ''}
              fullWidth
              variant="outlined"
              sx={{ backgroundColor: 'grey.200' }}
            />
          }
        />
        <SvvFormControl
          label={`${t('pre-commit-page.phone-number')} *`}
          htmlFor={'phone-number'}
          control={
            <Fragment>
              <TextField
                name={'phoneNumber'}
                id={'phone-number'}
                data-testid={'phoneNumber'}
                type="text"
                value={userData.phoneNumber || ''}
                fullWidth
                variant="outlined"
                onBlur={() => setTouched(true)}
                error={!isValid && touched}
                helperText={
                  !isValid && touched && t('pre-commit-page.phone-is-not-valid')
                }
                onChange={(
                  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
                ) => changeHandler(e)}
              />
              <FormHelperText>
                <Typography
                  variant="body1"
                  component="p"
                  sx={{ fontSize: '14px' }}
                >
                  {t('pre-commit-page.check-phone')}
                </Typography>
              </FormHelperText>
            </Fragment>
          }
        />
        <SvvFormControl
          htmlFor={'message'}
          label={t('pre-commit-page.message-to-repairshop')}
          control={
            <Fragment>
              <TextField
                id={'message'}
                name={'messageToRepairShop'}
                data-testid={'messageToRepairShop'}
                type="textarea"
                value={userData.messageToRepairShop || ''}
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                onChange={(
                  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
                ) => changeHandler(e)}
              />
            </Fragment>
          }
        />
      </Stack>
    </Box>
  )
}

export default UserInfo
